import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `EntradaAlmacen/addEntradaAlmacen`, method: 'POST', body: values, token: token})
}